import * as THREE from 'three';

export function clamp(value: number, min: number, max: number): number {
  return Math.min(Math.max(value, min), max);
}

/** Exponential damp (avoid THREE.Math* — incomplete in @types for r129). */
export function damp(current: number, target: number, lambda: number, dt: number): number {
  return current + (target - current) * (1 - Math.exp(-lambda * dt));
}

export function disposeObject3D(obj: THREE.Object3D) {
  obj.traverse((child) => {
    if (child instanceof THREE.Mesh) {
      child.geometry.dispose();
      const mats = child.material;
      if (Array.isArray(mats)) {
        mats.forEach((m) => m.dispose());
      } else {
        mats.dispose();
      }
    }
  });
}
